module.exports = __webpack_public_path__ + "img/108.efdbac88.jpg";